import { Component, ElementRef, OnInit } from "@angular/core";
import {AsyncPipe, NgClass, NgIf} from "@angular/common";
import { FormsModule } from "@angular/forms";

import { map, Observable } from "rxjs";

import { SavedSearchesService } from "../saved-searches.service";
import { SavedSearchModel } from "../saved-search.model";
import { DeliveryApiService } from "../../../../shared-library/delivery-api/delivery-api.service";
import { LinkModel } from "../../../../shared-library/delivery-api/models/link.model";
import { UmbracoLinkComponent } from "../../../../common-components/umbraco-link/umbraco-link.component";
import { PublishedContentModel } from "../../../../shared-library/delivery-api/models/published-content.model";
import { ExternalConfigurationService } from "../../../../shared-library/services/configuration/external-configuration.service";
import {DirectorySearchPageModel} from "../../../../shared-library/delivery-api/models/directory-search-page.model";
import {BrowserWindowService} from "../../../../shared-library/services/environment/browser-window.service";

@Component({
    selector: "pcg-ng-saved-searches-bar",
    templateUrl: "saved-searches-bar.component.html",
    imports: [
        NgIf,
        AsyncPipe,
        FormsModule,
        UmbracoLinkComponent,
        NgClass
    ],
    standalone: true
})
export class SavedSearchesBarComponent implements OnInit {
    public isSearchPage = false;
    public showForm = false;
    public formValue: SavedSearchModel;

    public savedSearchesPageLink$: Observable<Array<LinkModel>>;

    public constructor(
        public savedSearchesService: SavedSearchesService,
        public deliveryApiService: DeliveryApiService,
        private configurationService: ExternalConfigurationService<{ path: string }>,
        private domElement: ElementRef,
        private browserWindowService: BrowserWindowService
    ) {
    }

    public ngOnInit(): void {
        this.configurationService.initialize(this.domElement);

        this.savedSearchesService.savedSearches$.subscribe((savedSearches) => {
            this.formValue = savedSearches.find(s => s.url === window.location.href)
                || {id: "", name: "", description: "", url: window.location.href};
        });

        this.savedSearchesPageLink$ = this.deliveryApiService.getPage$<DirectorySearchPageModel>(this.configurationService.config?.path ?? window.location.pathname).pipe(
            map(directorySearchPage => directorySearchPage.properties.SavedSearchesPage)
        );

        this.deliveryApiService.getPage$<PublishedContentModel>(this.configurationService.config?.path ?? window.location.pathname)
            .subscribe(page => {
                this.isSearchPage = page.contentType === "DirectorySearchPage";
            });
    }

    public toggleForm(event: Event): void {
        event.preventDefault();

        this.showForm = !this.showForm;
    }

    public save(event: Event): void {
        event.preventDefault();

        this.formValue.url = window.location.href;
        if (!!this.formValue.id) {
            this.savedSearchesService.update(this.formValue);
        } else {
            this.savedSearchesService.create(this.formValue);
        }

        this.showForm = false;
    }

    public delete(event: Event): void {
        event.preventDefault();

        if (!!this.formValue.id) {
            this.savedSearchesService.delete(this.formValue);
        }

        this.showForm = false;
    }

    public manage(event: Event): void {
        event.preventDefault();

        this.savedSearchesPageLink$.subscribe(links => {
            if (links && links.length > 0) {
                const link = links[0];
                if (link && link.route && link.route.path) {
                    window.location.href = link.route.path;
                }
            }
        });

        this.showForm = false;
    }
}
